export const isEmailValid = (email) => {
  // email validation regex from the internet - https://stackoverflow.com/a/1373724
  // eslint-disable-next-line
  const re =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  return re.test(String(email).toLowerCase());
};

const isIntDatePartValid = (datePart, maxValue) => {
  const allowedCharsRegex = /^[0-9]+$/;
  const emptyCharsRegex = /^\s*$/;

  if (!datePart || emptyCharsRegex.test(String(datePart))) {
    return false;
  }
  if (datePart === "0") {
    return false;
  }
  if (datePart > maxValue) {
    return false;
  }
  if (!Number.isInteger(parseFloat(datePart))) {
    return false;
  }
  if (!allowedCharsRegex.test(String(datePart))) {
    return false;
  }

  return true;
};

export const isDayValid = (day) => {
  return isIntDatePartValid(day, 31);
};

export const isMonthValid = (month) => {
  return isIntDatePartValid(month, 12);
};

export const isYearValid = (year) => {
  const allowedCharsRegex = /^[0-9]+$/;
  const emptyCharsRegex = /^\s*$/;

  if (!year || emptyCharsRegex.test(String(year))) {
    return false;
  }
  if (year.length < 4) {
    return false;
  }
  if (year < 1900) {
    return false;
  }
  if (!Number.isInteger(parseFloat(year))) {
    return false;
  }
  if (!allowedCharsRegex.test(String(year))) {
    return false;
  }

  return true;
};

const isCalendarDateValid = (day, month, year) => {
  const d = parseInt(day, 10);
  const m = parseInt(month, 10);
  const y = parseInt(year, 10);
  if (isNaN(d) || isNaN(m) || isNaN(y)) {
    return false;
  }
  const date = new Date(y, m - 1, d);
  return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
};

export const isDateValid = (day, month, year) => {
  return isDayValid(day) && isMonthValid(month) && isYearValid(year) && isCalendarDateValid(day, month, year);
};

const isDateInThePast = (day, month, year) => {
  const today = new Date(new Date().toDateString());

  let monthIndex = month - 1; // month is 0-indexed
  const date = new Date(new Date(year, monthIndex, day).toDateString());

  return date < today;
};

export const isDateInThePastValid = (date) => {
  const year = date.year;
  const month = date.month;
  const day = date.day;

  return isDateValid(day, month, year) && isDateInThePast(day, month, year);
};

export const isTextValid = (text) => {
  const emptyCharsRegex = /^\s*$/;

  if (!text || emptyCharsRegex.test(String(text))) {
    return false;
  }

  return true;
};

export const isNationalInsuranceNumberValid = (value) => {
  if (!value) return false;
  const normalised = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  const re = /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z][0-9]{6}[A-D]$/;
  if (!re.test(normalised)) return false;
  const prefix = normalised.slice(0, 2);
  const prohibitedPrefixes = ["BG", "GB", "KN", "NK", "NT", "TN", "ZZ"];
  return !prohibitedPrefixes.includes(prefix);
};

export const validateNationalInsuranceNumber = (value) => {
  if (!value || !value.trim()) {
    return { hasError: true, message: "Enter your National Insurance number" };
  }
  if (!isNationalInsuranceNumberValid(value)) {
    return { hasError: true, message: "Enter a National Insurance number in the correct format" };
  }
  return { hasError: false, message: "" };
};
